module.exports = __webpack_public_path__ + "assets/img/project-quiz-thumb.b2f35266.png";